<template>
  <ml-dialog
    ref="dialogRef"
    title="工单审核"
    width="900px"
    @click-submit="handleSubmit"
    @click-close="handleCancel"
  >
    <template #body>
      <div>1222</div>
    </template>
  </ml-dialog>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'DemoDialog',
  setup(props, { emit }) {
    const dialogRef = ref(null)
    const openDialog = () => {
      if (dialogRef.value) {
        dialogRef.value.open()
      }
    }
    const closeHandle = () => {
      emit('close')
    }
    // 暴露给父组件使用
    return {
      dialogRef,
      openDialog,
      closeHandle
    }
  }
}
</script>
